import CollapsibleContainer from "Components/CollapsibleContainer";

import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { buttonTrackId } from "Utils/analytics";
import React, { PropsWithChildren, useState } from "react";

interface Props {
  children: React.ReactNode;
  buttonText: string;
}

export const DropdownContent = (
  props: PropsWithChildren<Props>,
): React.ReactElement => {
  const { children, buttonText } = props;
  const [showContent, toggleShowContent] = useState(false);
  const buttonId = `dropdown-button__${buttonText}`;
  const buttonTrackerId = buttonTrackId(`${buttonText}`);

  return (
    <>
      <ThemedButton
        id={buttonId}
        className={buttonId}
        variant="text"
        iconRight={showContent ? "chevron-up" : "chevron-down"}
        trackId={buttonTrackerId}
        data-trackid={buttonTrackerId}
        onClick={() => toggleShowContent(!showContent)}
      >
        {buttonText}
      </ThemedButton>

      <CollapsibleContainer isOpen={showContent}>
        {children}
      </CollapsibleContainer>
    </>
  );
};
